export function getUnknownErrorMessage(error: unknown, fallbackMessage = "An error occurred."): string {
  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === "string") {
    return error;
  }

  if (typeof error === "object" && error != null && "message" in error && typeof error.message === "string") {
    return error.message;
  }

  return fallbackMessage;
}
